import './App.css';
import Navbar from './component/Navbar';
import UploadProduct from './component/UploadProduct';
import AdminProductForm from './pages/AdminProductForm';
import HomePage from './pages/HomePage';
import { Routes, Route } from 'react-router-dom'
import LoginPage from './pages/LoginPage';
import SellerUpload from './pages/SellerUpload';
import React, { useState } from 'react';
import Unauthorized from './pages/Unauthorized';
import { CartProvider } from './component/CartContext';
import Icon from "./assets/whatsapp.png"
import Cart from "./pages/Cart"
import { Toaster } from 'react-hot-toast';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Testimonial from './pages/Testimonial';
import ListingDetail from './pages/ListingDetail';
import AddPropertyPage from './pages/AddPropertyPage';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from 'firebase/auth';
import { auth } from './FirebaseConfig';
import { useNavigate } from 'react-router-dom';
import ProductPage from './pages/ProductPage';
import Addtocart from './pages/Addtocart';
import CheckoutPage from './component/CheckoutPage';
import RestaurantMenu from './pages/RestaurantMenu';
import Footer from './component/Footer';
import Service from './pages/Service';
import { useEffect } from 'react';
import Profile from './pages/Profile';
import SellerRoute from './SellerRoute';
import BuyerProfile from './pages/BuyerProfile';
import ChatRoom from './pages/ChatRoom';
import CampusKeys from './pages/CampusKeys';
import ListingForm from './pages/ListingForm';
import PropertyPage from './pages/PropertyPage';
import RecentHistory from './pages/RecentHistory';
import AdminDashboard from './pages/AdminDashboard';
import ReferralJoin from './pages/ReferralJoin';
import LeaderBoard from './pages/LeaderBoard';
import PromoteProduct from './component/PromoteProduct';
import LearnMore from './pages/LearnMore';
// import AdminNotificationPage from './pages/AdminNotificationPage';
import ThanksPage from './pages/ThanksPage';
import Verify from './pages/Verify';
import AdminVerification from './pages/AdminVerification';
import AddFoodForm from './pages/AddFoodForm';
import Landing from './pages/Landing';
import EmployeeDashboard from './pages/EmployeeDashboard';
import SplashScreen from './SplashScreen';  
import TermsAndConditions from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import StorePage from './pages/StorePage';


function App() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [saveProfile, setSaveProfile] = useState(false);
  const [isSigned, setisSigned] = useState(() => {
    return localStorage.getItem("isSigned") === "true";
  });

  const adminEmails = ["davidalaga2@gmail.com"];
  const CampusEmails = ["davidalaga2@gmail.com", "daniyung07@gmail.com", "adaugoikwegbu10@gmail.com"];
  const Employees = ["daniyung07@gmail.com", "davidalaga2@gmail.com", "ekwuemesat@gmail.com"];

  const [isSignUp, setIsSignUp] = useState(false);

  const getAuthErrorMessage = (errorCode) => {
    switch (errorCode) {
      case 'auth/invalid-email':
        return 'The email address you entered is not valid.';
      case 'auth/user-not-found':
        return 'No account found with this email. Please sign up first.';
      case 'auth/wrong-password':
        return 'Incorrect password. Please try again.';
      case 'auth/invalid-credential':
        return 'Incorrect email or password. Please check and try again.';
      case 'auth/user-disabled':
        return 'This account has been disabled. Please contact support.';
      case 'auth/too-many-requests':
        return 'Too many failed attempts. Please wait a few minutes and try again.';
      case 'auth/email-already-in-use':
        return 'An account with this email already exists. Try signing in instead.';
      case 'auth/weak-password':
        return 'Your password is too weak. Use at least 6 characters.';
      case 'auth/operation-not-allowed':
        return 'Sign up is currently disabled. Please contact support.';
      case 'auth/network-request-failed':
        return 'No internet connection. Please check your network and try again.';
      case 'auth/timeout':
        return 'The request timed out. Please check your connection and try again.';
      case 'auth/popup-closed-by-user':
        return 'Sign in was cancelled. Please try again.';
      case 'auth/requires-recent-login':
        return 'Please sign out and sign back in to continue.';
      default:
        return 'Something went wrong. Please try again.';
    }
  };

  const handleAuth = async (e) => {
    e?.preventDefault();
    try {
      if (isSignUp) {
        await createUserWithEmailAndPassword(auth, email, password);
        localStorage.setItem("isSigned", "true");
        setisSigned(true);
        toast.success('Account created successfully!');
        navigate('/Profile');
      } else {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        localStorage.setItem("isSigned", "true");
        setisSigned(true);
        if (adminEmails.includes(user.email)) {
          navigate('/Admin');
        } else {
          navigate('/Profile');
        }
      }
    } catch (err) {
      const friendlyMessage = getAuthErrorMessage(err.code);
      toast.error(friendlyMessage);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  // ── Splash screen ──────────────────────────────────────────
  if (loading) {
    return <SplashScreen />;
  }
  // ──────────────────────────────────────────────────────────

  return (
    <CartProvider>
      <div className="App bg-black min-h-screen">
        <Toaster position="top-center" reverseOrder={false} />
        <Navbar
          isSigned={isSigned}
          adminEmails={['davidalaga2@gmail.com', 'daniyung07@gmail.com']}
          CampusEmails={["davidalaga2@gmail.com", "daniyung07@gmail.com", "adaugoikwegbu10@gmail.com"]}
          setisSigned={setisSigned}
        />
        <Routes>
          <Route path='/' exact element={<HomePage isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/listing/:listingId" element={<ListingDetail isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/chat/:receiverId" element={<ChatRoom isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/AddProperty" element={<AddPropertyPage isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/CampusKeys" element={<CampusKeys isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/Listing" element={<PropertyPage isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/ListForm" element={<ListingForm isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/mychats" element={<RecentHistory isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/verify" element={<Verify isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/testimonial" element={<Testimonial isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/thanks" element={<ThanksPage isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/terms" element={<TermsAndConditions isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path="/privacy" element={<PrivacyPolicy isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/Admin' exact element={
            <AdminProductForm
              userEmail={auth.currentUser?.email}
              adminEmails={['davidalaga2@gmail.com']}
              isSigned={isSigned}
              setisSigned={setisSigned}
            />}
          />
          <Route path='/AdminVerify' exact element={
            <AdminVerification
              userEmail={auth.currentUser?.email}
              adminEmails={['davidalaga2@gmail.com']}
              isSigned={isSigned}
              setisSigned={setisSigned}
            />}
          />
          <Route path='/uploadProduct' exact element={<UploadProduct isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route
            path='/Landing'
            exact
            element={
              <Landing
                handleAuth={handleAuth}
                email={email}
                setEmail={setEmail}
                setPassword={setPassword}
                isSignUp={isSignUp}
                setIsSignUp={setIsSignUp}
                isSigned={isSigned}
                setisSigned={setisSigned}
              />
            }
          />
          <Route path='/Login' exact element={
            <LoginPage
              handleAuth={handleAuth}
              isSigned={isSigned}
              email={email}
              setEmail={setEmail}
              setisSigned={setisSigned}
              setPassword={setPassword}
              isSignUp={isSignUp}
              setIsSignUp={setIsSignUp}
            />}
          />
          <Route path='/seller' exact element={
            <SellerRoute adminEmails={['davidalaga2@gmail.com', 'daniyung07@gmail.com']}>
              <SellerUpload isSigned={isSigned} setisSigned={setisSigned} />
            </SellerRoute>}
          />
          <Route path='/Profile' exact element={<Profile isSigned={isSigned} setisSigned={setisSigned} saveProfile={saveProfile} setSaveProfile={setSaveProfile} />} />
          <Route path='/unauthorized' exact element={<Unauthorized isSigned={isSigned} setisSigned={setisSigned} saveProfile={saveProfile} setSaveProfile={setSaveProfile} />} />
          <Route path='/product' exact element={<ProductPage isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/campusAdmin' exact element={
            <AdminDashboard
              CampusEmails={['davidalaga2@gmail.com', 'adaugoikwegbu10@gmail.com']}
              userEmail={auth.currentUser?.email}
              isSigned={isSigned}
              setisSigned={setisSigned}
            />}
          />
          <Route path='/buyer' exact element={<BuyerProfile isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/cart' exact element={<Cart isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/checkout' exact element={<CheckoutPage isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/learn' exact element={<LearnMore isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/promote' exact element={<PromoteProduct isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/restuarant' exact element={<RestaurantMenu isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/JoinReferral' exact element={<ReferralJoin isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/LeaderBoard' exact element={<LeaderBoard isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/product/:id' exact element={<Addtocart isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/store/:sellerId' exact element={<StorePage isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/service' exact element={<Service isSigned={isSigned} setisSigned={setisSigned} />} />
          <Route path='/Employee' exact element={
            <EmployeeDashboard
              Employees={['davidalaga2@gmail.com', 'daniyung07@gmail.com']}
              userEmail={auth.currentUser?.email}
              isSigned={isSigned}
              setisSigned={setisSigned}
            />}
          />
          <Route path='/foodform' exact element={<AddFoodForm isSigned={isSigned} setisSigned={setisSigned} />} />
        </Routes>

        <ToastContainer position="top-right" autoClose={4000} theme="dark" />
        <Footer />
        <a
          href="https://wa.me/2349017177993?text=Hello%20I%20need%20help%20with%20uCart"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-5 right-5 z-20 bg-green-500 p-3 rounded-full shadow-lg"
        >
          <img src={Icon} alt="Chat with us" className="w-6 h-6 text-white" />
        </a>
      </div>
    </CartProvider>
  );
}

export default App;